import styled from "styled-components";

export const StyledWrapper = styled.div`
  > div {
    z-index: 2000;
    position: fixed !important;
  }
`;
